import { CognitoUserWithChallengeName } from '../../../Components/Auth/type';

export const getCognitoUserSignInUserSession = (cognitoUser: CognitoUserWithChallengeName | null) => {
  const userSession = cognitoUser?.getSignInUserSession();
  return userSession ?? null;
};
